<template lang="pug">
  //.container
    //.col-12#be-a-host
      .be-a-host-box.text-white
        .h2 Möchten auch Sie Ihren Betrieb bei touriDat listen?
        p Für ein Lächeln des Gastes zählt jedes Detail. Wenn das auch Ihr Anspruch ist, bewerben Sie sich jetzt und freuen Sie sich auf viele neue und niveauvolle Gäste!
        a.button.button-secondary.button-td-grey.oc.btn-block(href="/werde-ein-gastgeber") jetzt bewerben
  section.become-a-host.position-relative
    .be-a-host-box.txt-white.p-3
      .h2 Möchten auch Sie Ihren Betrieb bei touriDat listen?
      p Für ein Lächeln des Gastes zählt jedes Detail. Wenn das auch Ihr Anspruch ist, bewerben Sie sich jetzt und freuen Sie sich auf viele neue und niveauvolle Gäste!
      a.button.button-secondary.button-td-grey.oc.btn-block(href="/werde-ein-gastgeber") jetzt bewerben
</template>

<script>
export default {
  name: "BecomeAHost",
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_colors.scss";
.become-a-host {
  height: 60vh;
  min-height: 500px;
  background-image: url("https://s3-cloud.td-cdn.de/Images/makaira/home/be-a-host-compressed.jpg");
  background-size: cover;
  background-position: center 0;
  background-repeat: no-repeat;
  background-attachment: fixed;
  @supports (-webkit-hyphens: none) {
    // safari only
    background-attachment: scroll !important;
  }

  @supports (-webkit-overflow-scrolling: touch) {
    background-attachment: scroll !important;
  }
  overflow: hidden;
  margin-top: -50px;
  position: relative;
  &:after,
  &:before {
    content: "";
    position: absolute;
    height: 200px;
    width: 150%;
    left: 50%;
    background-color: inherit;
  }
  &:before {
    top: 0;
    transform: translate(-50%, -50%) rotate(-5deg);
  }
  &:after {
    bottom: 0;
    transform: translate(-50%, 50%) rotate(-5deg);
  }

  .be-a-host-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: calc(100% - 50px);
    max-width: 450px;
    margin: 0 auto;
    background-color: rgba($td-grey-darker, 0.8);
    border-radius: 10px;
    backdrop-filter: blur(7px);
  }
}
</style>
